module.exports = __webpack_public_path__ + "img/2.c54e7c10.png";